if (!window.customElements.get('media-grid-item-video')) {

    class MediaGridItemVideo extends HTMLElement {
      constructor() {
        super();
        this.gsap = null;
        this.isInitialized = false;
        this.playButton = null;
        this.desktopVideo = null;
        this.mobileVideo = null;
        this.currentVideo = null;
        this.isPlaying = false;
      }
    
      connectedCallback() {
        // Prevent multiple initializations
        if (this.isInitialized) return;
        
        // Wait for GSAP to be ready before initializing
        whenReady('motion', (motion) => {
          this.motion = motion;
          
          // Add a small delay to ensure everything is ready
          setTimeout(() => {
            if (!this.isInitialized) {
              this.init();
              this.isInitialized = true;
            }
          }, 100);
        });
      }
    
      init() {
        // Find the play button and videos
        this.playButton = this.querySelector('button');
        this.desktopVideo = this.querySelector('.banner-media__video-desktop');
        this.mobileVideo = this.querySelector('.banner-media__video-mobile');
        
        // Determine which video to use based on screen size
        this.setCurrentVideo();
        
        // Add event listeners
        if (this.playButton) {
          this.playButton.addEventListener('click', () => this.handlePlayClick());
        }
        
        // Listen for window resize to switch videos
        window.addEventListener('resize', () => {
          this.setCurrentVideo();
        });
      }
    
      setCurrentVideo() {
        const isMobile = window.innerWidth <= 767;
        
        if (isMobile && this.mobileVideo) {
          this.currentVideo = this.mobileVideo;
        } else if (this.desktopVideo) {
          this.currentVideo = this.desktopVideo;
        } else {
          // Fallback to any video element if specific classes don't exist
          this.currentVideo = this.mobileVideo || this.desktopVideo || this.querySelector('video');
        }
      }
    
      handlePlayClick() {
        if (!this.currentVideo) return;
        
        if (this.isPlaying) {
          this.pauseVideo();
        } else {
            this.playVideo();
            // Use GSAP for smooth button fade out
            if (this.gsap && this.playButton) {          
              this.gsap.set(this.playButton, {
                transition: "none"
              });
              this.gsap.to(this.playButton, {
                duration: 0.65,
                opacity: 0,
                delay: .15,
                ease: 'power2.out',
                onComplete: () => {
                  this.playButton.style.display = 'none';
                }
              });
            } else {
              this.playButton.style.opacity = 0;
              this.playButton.style.visibility = 'hidden';
            }
        }
      }
    
      playVideo() {
        if (!this.currentVideo) return;
        
        // Add controls to the video
        this.currentVideo.controls = true;
        
        // Play the video
        this.currentVideo.play().then(() => {
          this.isPlaying = true;
        //   this.updatePlayButton();
        }).catch(error => {
          console.error('Error playing video:', error);
        });
      }
    
      pauseVideo() {
        if (!this.currentVideo) return;
        
        this.currentVideo.pause();
        this.isPlaying = false;
        this.updatePlayButton();
      }
    
      updatePlayButton() {
        if (!this.playButton) return;
        
        // Use GSAP for smooth button fade in
        if (this.gsap) {
          this.gsap.to(this.playButton, {
            duration: 0.3,
            opacity: 1,
            visibility: 'visible',
            ease: 'power2.out'
          });
        } else {
          this.playButton.style.opacity = 1;
          this.playButton.style.visibility = 'visible';
        }
      }
    
      disconnectedCallback() {
        // Clean up event listeners if needed
        if (this.playButton) {
          this.playButton.removeEventListener('click', this.handlePlayClick);
        }
        window.removeEventListener('resize', this.setCurrentVideo);
      }
    }
    
    // Register the web component
    customElements.define('media-grid-item-video', MediaGridItemVideo);
  
  }